<template>
  <div class="aboutus-content">
    <banner url="aboutus" hasDivider clazz="aboutus-banner">
      <template slot="buttons">
        <el-button class="banner-button" round @click="this.goConsult">立即咨询</el-button>
      </template>
    </banner>
    <div class="aboutus-section1">
      <el-tabs type="border-card" class="aboutus-tab">
        <el-tab-pane>
          <h1 class="aboutus-tabpane" slot="label">公司介绍</h1>
          <div class="section1-tab1 tc">
            <div class="tab1-area1">
              <img class="area1-img" src="../../assets/img/aboutUs/tab1-area1-1.png" alt="我们能为您提供什么价值？"/>
              <div class="area1-content dib tl">
                <h1 class="content-title">我们能为您提供什么价值？</h1>
                <span class="left-comma">“</span>
                <div class="content-main dib">
                  在全球范围内，甄云提供一站式采购数字化管理平台，为您提供采购管理解决方案，帮您重构采购业务流程，从而有效提升供应效率，降低风险，成本。
                  <br/>
                  迄今为止，甄云已陆续服务中车，碧桂园集团、新希望集团、光明乳业、潍柴动力、TCL、东方电气、普洛斯、天合光能、石药集团、隆基股份、腾讯旗下公司等600+家国内外知名大中型企业，丰富的实施经验，为您提供可行的采购管理解决方案。
                </div>
                <span class="right-comma">”</span>
              </div>
            </div>
            <div class="tab1-area2">
              <h1 class="area2-title">一个平台，一份承诺，推动企业采购变革</h1>
              <div class="area2-divider dib"></div>
              <div class="content-line">
                <div class="line-misc dib first tl">
                  <div class="number">01</div>
                  <h2 class="title">全球采购管理视野和先进技术的结合</h2>
                  <p class="misc">
                    每个公司和部门都有其特色，我们的采购系统涵盖独立部署和云平台及定制开发，根据您公司不同需求，按需而做，实现不同部门之间更好地协作，降低成本，实时可见。采用全球先进开发技术，并遵循不同行业特点，为企业提供实践方案。
                  </p>
                </div>
                <img class="line-image" src="../../assets/img/aboutUs/tab1-line-first.png" alt="全球采购管理视野和先进技术的结合"/>
              </div>
              <div class="content-line">
                <img class="line-image" src="../../assets/img/aboutUs/tab1-line-second.png" alt="一个工具，满足您的所有需求"/>
                <div class="line-misc dib second tl">
                  <div class="number">02</div>
                  <h1 class="title">一个工具，满足您采购全流程管理</h1>
                  <div class="misc">
                    <p>共赢生态：融合核心企业，上游供应商，云平台资源，构建您采购所需生态圈</p>
                    <p>互联信息：覆盖企业内部采购供应信息，打通企业与供应商的信息流商流，物流，资金流</p>
                    <p>采购流程闭环管理：从采购需求，供应商管理到付款结算过程全周期管理，系统无缝覆盖全采购业务流程。</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab1-area3">
              <h1 class="title">甄云SRM供应链管理系统</h1>
              <h2 class="subtitle">一站式提升采购供应管理效率，实现增效降本</h2>
              <div class="buttons">
                <el-button class="area3-button demo" round @click="goRegister('guanyuwomen-guanli-tiyan')">申请体验</el-button>
                <el-button class="area3-button consult" round @click="goConsult">立即咨询</el-button>
              </div>
            </div>
            <div class="tab1-area4">
              <h1 class="area4-title">为什么选择我们</h1>
              <div class="area4-divider dib"></div>
              <div class="area4-main">
                <div class="content-box first dib">
                  <img class="box-icon" src="../../assets/img/aboutUs/1_iocn.png" alt="我们的发展"/>
                  <h2 class="box-title">我们的发展</h2>
                  <p class="box-content tl">
                    甄云SRM自2005年开始产品研发，迄今为止已进行四次大版本升级迭代，我们不断创新和优化我们的解决方案，结合大数据以及其他生态合作伙伴来更好的服务企业，为企业采购管理赋能。
                  </p>
                </div>
                <div class="content-box second dib">
                  <img class="box-icon" src="../../assets/img/aboutUs/2_iocn.png" alt="专家随时为您服务"/>
                  <h1 class="box-title">专家随时为您服务</h1>
                  <p class="box-content tl">
                    公司60%以上为产品研发人员。销售及交付团队大多来自全球知名管理软件厂商、各大互联网公司和咨询公司，建立通畅的服务沟通网络年允许故障小于0.4小时，为客户提供优质咨询和解决方案。
                  </p>
                </div>
                <div class="content-box third dib">
                  <img class="box-icon" src="../../assets/img/aboutUs/3_iocn.png" alt="为客户创造和提升利润"/>
                  <h1 class="box-title">为客户创造和提升利润</h1>
                  <p class="box-content tl">
                    我们将致力于了解、预期并超越客户的期望和需求，通过在技术、方法、人力资源的提升，赢得并维持客户的忠诚度我们将通过服务的提供和延伸实施，帮助客户不断发展并使其得到快速、高效的经济回报。
                  </p>
                </div>
              </div>
            </div>
            <div class="tab1-area5">
              <h1 class="area5-title">企业简介</h1>
              <div class="area5-divider dib"></div>
              <div class="area5-main">
                <div>企业名称:	上海甄云信息科技有限公司</div>
                <div>官网：www.going-link.com</div>
                <div>企业简介：<br>上海甄云信息科技有限公司是国内采购数字化管理平台提供商，成立于2017年6月，致力于企业数字化采购变革，为中大型企业提供企业生产性及非生产性物资采购数字化解决方案，推动企业采购更加智能、高效、透明、降本，赋能企业经营发展降本提效。
                  公司总部位于上海，从2005年就推出SaaS采购数字化产品，专注采购数字化升级，从用户真实应用场景出发，解决企业采购管理应用实际痛点。目前，甄云科技产品已陆续服务全球30多个行业，提供行业解决方案。
                </div>
                <div>企业产品服务：<br>甄云SRM，为企业的采购与交易提供一体化的智能管理平台与解决方案。</div>
                <div>企业发展历程：<br>
                  2017年6月：上海甄云信息科技有限公司正式成立，甄云SRM基于云平台为企业供应链提供数字化管理、数字化服务。<br>
                  2018年11月：甄云科技获得A股上市公司汉得信息、京东和众麟资本1.5亿元的A轮融资。<br>
                  2019年12月：甄云数字化采购平台正式发布并全面推广，定位于中大型企业公有云业务。<br>
                  2020年4月：甄云科技发布云战略，全面升级采购云服务能力。<br>
                  2020年11月： 甄云科技完成B轮融资，总额达3亿元，由蓝湖资本领投，德同资本、红点创投中国基金、钟鼎资本及众麟资本等机构资本跟投。</div>
                <div>企业文化理念：<br>链接企业采购未来</div>
                <div>企业地址：<br>公司地址：上海市青浦区嘉松中路5888号A座10F</div>
                <div>企业荣誉：<br>
                  1、甄云科技入选上海市经济和信息化委员会发布“2020上海软件和信息技术服务业高成长百家”<br>
                  链接见政府网站公示名单：http://www.sheitc.sh.gov.cn/xxfw/20210104/e09cf319e8734ee89ef9e3b17a181a44.html<br>
                  2、甄云科技荣获中国软件和信息服务年度数字化采购管理领域领军企业<br>
                  发布链接：https://baijiahao.baidu.com/s?id=1690545276834675694&wfr=spider&for=pc<br>
                  3、甄云科技入选亿欧智库发布2020全球企业服务科技创新TOP50<br>
                  发布链接：https://www.iyiou.com/analysis/202012111012177<br>
                  4、甄云科技入选2020爱分析中国采购数字化厂商榜单<br>
                  发布链接：https://wenku.baidu.com/view/baa67b6f3b68011ca300a6c30c2259010202f3a5.html
                </div>

              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane>
          <h1 class="aboutus-tabpane" slot="label">联系我们</h1>
          <div class="section1-tab2 tc">
            <h2 class="tab2-title">联系我们</h2>
            <div class="tab2-divider dib"></div>
            <div class="tab2-content">
              <!--<baidu-map :center="center" :zoom="zoom" @ready="handler" class="content-map dib" @click="getClickInfo">-->
              <!--<bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>-->
              <!--<bm-marker :position="{lng: 121.16074, lat: 31.1733}"></bm-marker>-->
              <!--<bm-map-type :map-types="['BMAP_NORMAL_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT"></bm-map-type>-->
              <!--<bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>-->
              <!--<bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>-->
              <!--</baidu-map>-->
              <img class="content-map" src="../../assets/img/aboutUs/tab2-map.png" alt="联系我们"/>
              <img class="content-marker" src="../../assets/img/aboutUs/tab2-marker.png" alt="联系我们"/>
              <div class="content-inputer dib">
                <div class="info">
                  <el-input class="info-input dib" v-model="name" placeholder="姓名"></el-input>
                  <el-input class="info-input dib" :maxlength="11" v-model="telephone" placeholder="电话"></el-input>
                  <div class="textarea-container">
                    <textarea rows="5" cols="30" placeholder="留言信息..." class="textarea-inner"
                              @focus="borderFocus()" @blur="borderBlur()" v-model="message"></textarea>
                    <el-input :maxlength="4" placeholder="请输入验证码"
                              v-model="validate" class="validate-input">
                    </el-input>
                    <img class="validate-img" @click="changeCode" @mousedown="disableDrag"
                         :src="validateUrl" alt="请求失败,请检查网络"/>
                    <el-button id="submit" class="submit-button" @click="leaveMessage">请您留言</el-button>
                  </div>
                </div>
                <div class="content-info first tl">
                  <div class="pre-sales dib">售前热线：<span class="phone">400-116-0808</span></div>
                  <div class="address dib">公司地址：上海青浦区嘉松中路5888号</div>
                </div>
                <div class="content-info tl">
                  <div class="service dib">服务热线：<span class="phone">400-116-0808</span></div>
                  <div class="email dib">联系邮箱：<span class="email">marketing@going-link.com</span></div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane>
          <div class="aboutus-tabpane" slot="label">大事记</div>
          <div class="section1-tab3 tc">
            <div class="tab3-title">我们的发展历程</div>
              <div class="tab3-divider dib"></div>
            <div class="tab3-container">
              <div class="left-controller dib">
              <div class="arrow" @mousedown="moveLeft" @mouseup="destroyTimerL" @mouseleave="destroyTimerL">
                <i class="el-icon-arrow-left"></i>
              </div>
            </div>
              <div class="timeline-container dib">
              <div class="tab3-timeline dib" :style="{'right': timeline + 'px'}">
                <div class="timeline-item dib" v-for="(item, index) in timelineData" :key="index">
                  <div class="timeline-upper dib">{{item.time}}</div>
                  <div class="timeline-upper-divider dib"></div>
                  <div class="timeline-dot dib tc">
                    <div class="dot-outside dib tc">
                    <div class="dot-inside dib"></div>
                  </div>
                  </div>
                  <div class="timeline-lower-divider dib"></div>
                  <div class="timeline-lower dib">{{item.content}}</div>
                </div>
                <div class="timeline-end dib">
                  <div class="arrow"></div>
                </div>
              </div>
            </div>
              <div class="right-controller dib">
              <div class="arrow" @mousedown="moveRight" @mouseup="destroyTimerR" @mouseleave="destroyTimerR">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            </div>
          </div>
        </el-tab-pane>  -->
      </el-tabs>
    </div>
  </div>
</template>
<script>
import hoverButton from '../common/hoverButton.vue'
import banner from '../common/banner.vue'
import * as className from '../../assets/js/dom'

export default {
  inject: ['openRegister', 'goConsult'],
  name: 'aboutUs',
  metaInfo () {
    return {
      title: this.$seo.aboutus.title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.$seo.aboutus.keywords
      },
      {
        name: 'description',
        content: this.$seo.aboutus.description
      }]
    }
  },
  components: {
    hoverButton,
    banner
  },
  data () {
    return {
      route: this.$route.name.toLowerCase(),
      bannerData: [],
      name: '',
      telephone: '',
      message: '',
      validate: '',
      validateUrl: this.$global.globalPath + 'api/document/getcode',
      timeline: 0,
      timelineData: [
        {
          time: '2005年',
          content: '基于汉得WEB快速开发框架开发ISP1.0'
        },
        {
          time: '2013年',
          content: '加入标准化集中采购控制组建，战略寻源套件发布isp3.0'
        },
        {
          time: '2014年',
          content: '推出云SRM1.0的产品，并且支持共有云和私有云等多种部署方式'
        },
        {
          time: '2017年',
          content: '成立甄云信息，当年新客户超过70家'
        },
        {
          time: '2018年',
          content: 'A轮融资1.5亿，获得京东众麟资本投资客户超过300多家，员工超过300人'
        }
      ],
      timerR: '',
      timerL: '',
      maxDistance: 0,
      center: { lng: 0, lat: 0 },
      zoom: 17
    }
  },
  methods: {
    goRegister (code) {
      this.openRegister(false, code)
    },
    handler ({ BMap, map }) {
      this.center.lng = 121.155
      this.center.lat = 31.176
      this.zoom = this.zoom
    },
    chooseTab (str) {
      this.choice = str
    },
    borderFocus () {
      let Dom = document.getElementsByClassName('textarea-container')[0]
      className.addClass(Dom, 'focused')
    },
    borderBlur () {
      let Dom = document.getElementsByClassName('textarea-container')[0]
      if (className.hasClass(Dom, 'focused')) {
        className.removeClass(Dom, 'focused')
      }
    },
    leaveMessage () {
      let form = {
        name: this.name,
        mobile: this.telephone,
        msg: this.message,
        validate: this.validate
      }
      this.$api.post('/news/message', form, (r) => {
        if (r.code === 0) {
          this.$message.success('留言成功')
        } else {
          this.$message.error(r.data)
        }
      })
      this.name = ''
      this.telephone = ''
      this.message = ''
      this.validate = ''
      this.changeCode()
    },
    moveRight () {
      this.timerR = self.setInterval(() => {
        if (this.timeline < this.maxDistance) {
          this.timeline = this.timeline + 5
        } else {
          window.clearInterval(this.timerR)
        }
      }, 10)
    },
    moveLeft () {
      this.timerL = self.setInterval(() => {
        if (this.timeline >= 0) {
          this.timeline = this.timeline - 5
        } else {
          window.clearInterval(this.timerL)
        }
      }, 10)
    },
    destroyTimerL () {
      window.clearInterval(this.timerL)
    },
    destroyTimerR () {
      window.clearInterval(this.timerR)
    },
    changeCode () {
      let a = this.validateUrl
      this.validateUrl = ''
      this.$nextTick(() => {
        this.validateUrl = a
      })
    },
    disableDrag (event) {
      event.preventDefault()
    }
  },
  mounted () {
    let len = this.timelineData.length
    if (len > 5) {
      this.maxDistance = len % 5 ? 235 * (len % 5) : 235 * 5 * (len / 5 - 1) - 40
    } else {
      this.maxDistance = 0
    }
  },
  updated () {
  }
}
</script>
<style lang="scss">
  @import "../../../static/css/aboutUs.scss";
</style>



// WEBPACK FOOTER //
// aboutUs.vue?2ae40d30